import React, { useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

const StatsHighlight = () => {
  const stats = [
    { value: 250, symbol: '+', label: 'Volume des ventes', suffix: '%' },
    { value: 158, symbol: '', label: 'Points de vente' },
    { value: 70, symbol: '', label: 'Livraisons par semaine' },
    { value: 98, symbol: '', label: 'Taux de conformité', suffix: '%' }
  ];

  const CounterAnimation = ({ value, symbol, suffix = '' }) => {
    const controls = useAnimation();
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, amount: 0.5 });
    const [count, setCount] = React.useState(0);
    
    useEffect(() => {
      if (isInView) {
        let startValue = 0;
        const endValue = value;
        const duration = 2000; // 2 seconds
        const frameDuration = 1000 / 60; // 60fps
        const totalFrames = Math.round(duration / frameDuration);
        const increment = endValue / totalFrames;
        
        const counter = setInterval(() => {
          startValue += increment;
          if (startValue > endValue) {
            setCount(endValue);
            clearInterval(counter);
          } else {
            setCount(Math.floor(startValue));
          }
        }, frameDuration);
        
        return () => clearInterval(counter);
      }
    }, [isInView, value]);
    
    return (
      <div ref={ref} className="text-4xl md:text-5xl font-bold text-primary">
        {symbol}{count}{suffix}
      </div>
    );
  };

  return (
    <section className="section bg-gray-100">
      <div className="container-custom">
        <h2 className="section-title">Nos Performances</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-10">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-lg shadow-md text-center"
            >
              <CounterAnimation 
                value={stat.value} 
                symbol={stat.symbol} 
                suffix={stat.suffix || ''} 
              />
              <p className="text-gray-600 mt-2">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsHighlight; 